export const SAVE = 'stepTravelDelay.SAVE';
export const VALUE_CHANGED = 'stepTravelDelay.VALUE_CHANGED';
export const LOAD = 'stepTravelDelay.VALUE_LOAD';
export const NEXT = 'stepTravelDelay.NEXT';
export const RESET = 'stepTravelDelay.RESET';
export const RESET_DAMAGED_LOST_EXPENSE = 'stepTravelDelay.RESET_DAMAGED_LOST_EXPENSE';
export const RESET_DELAYED_LUGGAGE_EXPENSE = 'stepTravelDelay.RESET_DELAYED_LUGGAGE_EXPENSE';
export const RESET_COMPENSATION = 'stepTravelDelay.RESET_COMPENSATION';
//-------------------------------------------------------
export const RESET_TRIP_CANCELLATION_STATE = 'stepTravelDelay.RESET_TRIP_CANCELLATION_STATE';
export const RESET_TRAVEL_DELAY_STATE = 'stepTravelDelay.RESET_TRAVEL_DELAY_STATE';

export const REPORT_TO = {
  POLICE: '1',
  HOTEL_MANAGEMENT: '2',
  CRUISE_SHIP: '3',
  AIRLINE: '4',
  TOUR_GUIDE: '5',
  OTHER: '6',
  NOT_REPORT: '18',
};

export const CLAIMING_FOR = {
  PASSPORT_CREDIT_CARD: 'claimForPassportCreditCard',
  THEFT_OF_CASH: 'claimForTheftOfCash',
  LUGGAGE_AND_PERSONAL_EFFECTS: 'claimForLuggageAndPersonalEffect',
};



// WEBPACK FOOTER //
// ./app/containers/FastCover/StepTravelDelay/constants.js